import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";

export function ArrowDropDownIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 25 25" htmlColor="#1C1B1F" {...props}>
      <path d="m11.947 14.9-3.152-3.152a.5.5 0 0 1-.102-.146.46.46 0 0 1 .087-.492.42.42 0 0 1 .327-.135h6.639q.203 0 .327.137a.46.46 0 0 1 .125.32q0 .045-.14.316L12.905 14.9a.64.64 0 0 1-.48.209.64.64 0 0 1-.48-.209Z" />
    </MuiSvgIcon>
  );
}
export default ArrowDropDownIcon;
